// ═══════════════════════════════════════════════════════════════════
//  modules/wiki/brouillons.js
//  wikiBrouillonCle · wikiLireBrouillon · wikiEcrireBrouillon · wikiEffacerBrouillon
// ═══════════════════════════════════════════════════════════════════

// ═══════════════ Brouillon local (lot 2) ═══════════════
//  Sauvegarde le texte en cours de frappe dans le navigateur : une fausse
//  manip, un onglet fermé ou une session expirée ne coûtent plus le travail
//  de la demi-heure passée. Effacé dès que l'enregistrement serveur réussit.
export const wikiBrouillonCle = (page) => `wiki_brouillon_${page ? page.id : "nouvelle"}`;

export function wikiLireBrouillon(page) {
  try {
    const brut = localStorage.getItem(wikiBrouillonCle(page));
    if (!brut) return null;
    const d = JSON.parse(brut);
    // Un brouillon plus ancien que la dernière version serveur ne sert à rien
    if (page && d.horodatage < new Date(page.updated_at).getTime()) return null;
    if (Date.now() - d.horodatage > 14 * 24 * 3600 * 1000) return null; // 14 jours
    return d;
  } catch { return null; }
}

export function wikiEcrireBrouillon(page, data) {
  try { localStorage.setItem(wikiBrouillonCle(page), JSON.stringify({ ...data, horodatage: Date.now() })); } catch { /* quota */ }
}

export function wikiEffacerBrouillon(page) {
  try { localStorage.removeItem(wikiBrouillonCle(page)); } catch { /* ignore */ }
}
